<template>
  <div class="bottom-swiper">
    <div class="header">
      <div class="header-title">精品项目案例</div>
      <p>山西权华昌科技公司是一家专业从事数字信息解决方案,为客户提供软硬件开发、网站开发、手机APP、网络营销等服务的高新技术企业。
        权华昌科技长期专注软硬件开发和互联网定制业务，坚持”创新，开放合作”的经营理念。</p>
    </div>
    <div class="swiper-container3">
      <div class="swiper-wrapper">
        <div v-for="(item,index) in swiperList" :key="index" class="swiper-slide">
          <img :src="item.img" alt="">
          <div class="title">{{ item.title }}</div>
          <p class="desc" :title="item.desc">{{ item.desc }}</p>
        </div>
      </div>
    </div>
    <div class="button" @click="casedetail()">了解更多</div>
  </div>
</template>

<script>
import Swiper from 'swiper' // 注意引入的是Swiper
import 'swiper/css/swiper.min.css' // 注意这里的引入
export default {
  data () {
    return {
      swiperList: [
        {
          title: '城市大脑',
          capitalEnglish: 'CITY BRAIN',
          img: require('@/assets/imgs/case/case-01.png'),
          desc: '城市大脑将散落在城市各个角落的数据，包括政务数据、企业数据、社会数据、互联网数据等汇聚起来，用云计算、大数据、人工智能等前沿技术，帮助管理城市。它使城市具备类似人类大脑的功能，能够自我感知、自我学习、自我修正，让城市的各个“器官”协同工作，实现城市治理能力智能化、集约化、人性化，有效节约社会的公共资源。'
        },
        {
          title: '城市运营指挥中心',
          capitalEnglish: 'URBAN OPERATION COMMAND CENTER',
          img: require('@/assets/imgs/case/case-02.png'),
          desc: '城市运营管理中心，作为整个智慧城市管理的核心监测和控制中心，是智慧城市建设体系中的重点任务和关键要素。很多人都将它比喻为智慧城市的“大脑”与“中枢”，其实每块指挥大屏的背后，是海量的数据与强大的数据驱动在支撑。依托政府信息资源中心，统筹互联网、行业专网等各类网络环境中业务信息资源，汇聚经济、气象、环保、公安、交管地理等信息;依托大数据技术，通过数据分析和挖掘，构建完成分析模型体系，对城市状态进行运行监测、分析预警和指挥控制，使政府决策高效化、精确化和科学化。'
        },
        {
          title: '城市通',
          capitalEnglish: 'CITY LINK',
          img: require('@/assets/imgs/case/case-03.png'),
          desc: '城市通基于实名认证，以构建政府与企业、百姓之间的生态系统为目标，汇聚了地方各类高频的公共服务、政务服务、社会服务等资源，实现各类政务服务机构间的信息互信共享，免去市民多次现场办理、重复提交材料的烦恼，让市民享受一站式政务与民生服务。'
        },
        {
          title: '教育大数据平台',
          capitalEnglish: 'EDUCATION BIG DATA PLATFORM',
          img: require('@/assets/imgs/case/case-04.png'),
          desc: '按照国家《教育信息化2.0行动计划》标准，建设教育信息化软件产品和相关硬件设备，建设具有地方自身特色、符合地方自身情况的信息化综合管理平台;通过组织和业务流程再造，推动教育局与所属学校进行制度创新、管理创新，实现教育信息化、决策科学化和管理规范化;从而达到消除信息孤岛、建立信息与应用规范、提供集成个性化服务的目的并按照数字化校园的建设标准，打造数字校园示范校'
        },
        {
          title: '医疗大数据平台',
          capitalEnglish: 'MEDICAL BIG DATA PLATFORM',
          img: require('@/assets/imgs/case/case-05.png'),
          desc: '医疗大数据平台将分散在电子病历系统、检验系统、医学影象归档系统等不同信息系统中的临床数据进行统一管理，实现各类临床标准文档的结构化存储。最终实现药品收入、耗材收入、医疗服务收入、医疗运营成本等数据分析。'
        },
        {
          title: '智慧环保大数据平台',
          capitalEnglish: 'SMART ENVIRONMENTAL PROTECTION BIG DATA PLATFORM',
          img: require('@/assets/imgs/case/case-06.png'),
          desc: '智慧环保大数据平台，是依托智慧环保数据中心，将全区域的污染源数据、环境质量数据、环境业务数据全部关联、串联起来，进行整体分析，并应用BL、GIS对分析结果进行多形式的可视化展示。该平台整合衔接污染源全生命周期的各环境管理要素，形成“一源一档”动态管理档案，开创“一证式”管理模式，形成系统完整、权责清晰、监管有效的污染源管理新格局。'
        },
        {
          title: '智慧交通',
          capitalEnglish: 'NTELLIGENT TRANSPORTATION',
          img: require('@/assets/imgs/case/case-07.png'),
          desc: '以大数据、视频分析、人工智能等新技术为基础，构建智慧交通综合服务能力，形成自动发现道路拥堵、智能预判道路异常、智能化识别和发现车辆路侧停车、交通事故、占道施工等情形，提高交通事件处置效率;通过交通视频分析技术，实现自动感知和识别区内行驶的车辆。助力交通出行更加顺畅，提升道路交通流畅度和安全水平'
        },
        {
          title: '智慧物流',
          capitalEnglish: 'WISDOM LOGISTIC',
          img: require('@/assets/imgs/case/case-08.png'),
          desc: '借助云计算、物联网、大数据等新技术，建立以数据驱动的物流业务系统。利用机器人分拣、AGV小车、无人机、智能航线规划、车辆识别、高速监控等智能化应用构建物流全流程可视化、自动化的运输、装配、仓储，从而实现物流的自动化，信息化与智能化，提升物流系统的流转效率和运输成本。'
        },
        {
          title: '地下综合管廊综合监控平台',
          capitalEnglish: 'NTEGRATED MONITORING PLATFORM FOR UNDERGROUND',
          img: require('@/assets/imgs/case/case-09.png'),
          desc: '综合管廊管控运维平台，具备信息化、网络化、空间可视化、智慧化等特征，通过覆盖数据采集、传输、存储、处理、分析、管理等完整数据生命周期链条，实现对综合管廊的在线集中监控和运营维护管理等功能，能够对管廊内的管线及附属设备的运行状态、环境条件和人员的出入情况进行全天候监控，保证综合管廊的安全稳定运行。'
        },
        {
          title: '扬尘噪声在线监测系统',
          capitalEnglish: 'ON LINE MONITORING SYSTEM OF DUST AND NOISE',
          img: require('@/assets/imgs/case/case-10.png'),
          desc: '扬尘噪声在线监测系统用于对扬尘重点监控区和各种噪声环境功能区的连续自动监测，可对扬尘、噪声、气象等参数实时自动监测，并通过有线或无线等方式将监测数据传送到监管平台。平台通过云计算和大数据技术对数据进行计算分析，将分析后的实时数据、历史数据、报警信息、工地污染排名、趋势预测等功能展现给管理部门。'
        },
        {
          title: '贝塔射线环境颗粒物监测系统',
          capitalEnglish: '3ETA RAY ENVIRONMENTAL PARTICULATE MATTER MONITORINGSYSTEM',
          img: require('@/assets/imgs/case/case-11.png'),
          desc: '贝塔射线环境颗粒物监测系统是利用低能量C14作为B射线原，空气中的颗粒物经过切割器切割后，根据B射线穿过清吉滤纸和采集有颗粒物的滤纸时的两次B射线的强度和B射线的衰减，计算出表面富集的颗粒物的质量，结合采样体积数据，计算出颗粒物的浓度。监测仪具备执法计量、超标抓拍、定时抓拍、事后再现颗粒物污染画面等功能。'
        },
        {
          title: '公路隧道智能安全综合监控系统',
          capitalEnglish: 'INTELLIGENT SAFETY INTEGRATED MONITORING SYSTEM FORHIGHWAY TUNN',
          img: require('@/assets/imgs/case/case-12.png'),
          desc: '公路隧道智能安全综合监控系统，利用隧道内安装的各类检测传感器和PLC控制设备对交通、环境及设备状态数据进行控制、采集、分析及处理，并提供决策及预案编排功能。系统集成了数据库服务、应用服务、现场PLC数据传输及底层传感控制设备，接入方式灵活，兼具高吞吐量、高并发和高性能等优点。'
        },
        {
          title: '轨道行走智能检测平台',
          capitalEnglish: 'NTELLIGENT DETECTION PLATFORM FOR TRACK WALKING',
          img: require('@/assets/imgs/case/case-13.png'),
          desc: '轨道行走智能检测平台使用精密惯性测量、图像识别、视象检测、多源信息融合和健康管理等先进检测技术，由轨道行走平台、动力牵引平台、轨道几何参数测量系统、钢轨波磨处理系统、接触网图像识别系统组成，用于测量轨道的各项几何参数、长短波下钢轨磨耗引起的变化、接触网几何参数。'
        },
        {
          title: '铁路异物入侵检测系统',
          capitalEnglish: 'RAILWAY FOREIGN MATTER INTRUSION DETECTION SYSTEM',
          img: require('@/assets/imgs/case/case-14.png'),
          desc: '在铁道沿线布置若干激光扫描单元对轨面进行扫描，实时监测入侵物体;核心控制单元提取入侵对象轮廓特征，并联动微光夜视球机进行抓拍，应用神经网络算法，识别入侵物，实现拍照、报警、上传监控平台等功能。系统主要应用于铁路沿线易发生落石、落物、泥石流及异物入侵等影响行车安全的区域。产品性能达到国内领先水平。'
        },
        {
          title: '车辆轮廓动态测量系统',
          capitalEnglish: 'VEHICLE CONTOUR DYNAMIC MEASUREMENT SYSTEM',
          img: require('@/assets/imgs/case/case-15.png'),
          desc: '车辆轮廓动态测量系统通过在车辆通行区域架设测量门架安装激光扫描设备，以一定的采样频率，对通过车辆进行三维动态扫描，实现对车辆长宽高尺寸的不停车检测。系统采用激光-时间飞行原理，通过非接触式脉冲激光测距，将扫描产生的距离信息转化为车辆长宽高尺寸，系统的应用能够大幅提升高速公路治超工作的自动化程度。'
        },
        {
          title: '自动人脸识别测温系统',
          capitalEnglish: 'AUTOMATIC FACE RECOGNITION TEMPERATURE MEASUREMENTSYSTEM',
          img: require('@/assets/imgs/case/case-16.png'),
          desc: '系统采用双目摄像机对人体面部表面温度进行非接触快速动态测量，集热成像测温、人脸智能侦测、人脸识别等多项技术于一体，可以完成人脸的抓拍、比对，尤其是在戴口罩的情况下也能进行剩余特征点的大概率面部识别，实现人员信息、体温信息、出入信息的对应集成及综合管理，为疫情防控提供了重要的基础数据。'
        },
        {
          title: '智慧水务云平台',
          capitalEnglish: 'SMART WATER CLOUD PLATFORM',
          img: require('@/assets/imgs/case/case-17.png'),
          desc: '水·物·云”一一智慧水务云平台以一个云平台、一个云数据中心、三大管理体系、一个大数据辅助决策平台、N个业务应用的“1131N”的模式构建完整的新型智慧水务生态体系，高度整合水务信息资源并加以开发利用，通过物联设备立体感知融水司生产、环境、状态等的全方位变化，对数据进行传输存储和处理、实现海量数据的智能分析，为水司生产、经营服务和管理提供决策支撑，从而达到“智慧状态”'
        },
        {
          title: '融媒体',
          capitalEnglish: 'MEDIA CONVERGENCE',
          img: require('@/assets/imgs/case/case-18.png'),
          desc: '媒体融合平台建设，以推动广播、电视传统媒体与新兴媒体的高度融合，实现一次采集、多种生成、多元传播的生产工艺，将融媒体中心打造成形态多样、手段先进、具有竞争力的新型媒体发布矩阵。'
        }
      ]
    }
  },
  mounted () {
    this.getSwiper()
  },
  methods: {
    getSwiper () {
      this.swiper = new Swiper('.swiper-container3', {
        loop: true, // 无缝
        autoplay: { // 自动开始
          delay: 3000, // 时间间隔
          disableOnInteraction: false //* 手动操作轮播图后不会暂停*
        },
        paginationClickable: true,
        centeredSlides: true,
        slidesPerView: 4,
        spaceBetween: 20 // 间隔

      })
    },
    casedetail () {
      this.$router.push({ name: 'projectcase' })
    }
  }
}
</script>

<style lang="scss" scoped>
.bottom-swiper {
  width: 100%;
  background: #fff;
}
.header {
  text-align: center;
  overflow: hidden;
  .header-title {
    font-size: 36px;
    font-family: Source Han Sans SC;
    font-weight: bold;
    color: #252930;
    margin: 120px 0 24px;
  }
  p {
    width: 834px;
    margin: 0 auto;
    font-size: 14px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #9fa3ac;
  }
}
.swiper-container3 {
  width: 100%;
  // height: 665px;
  overflow-x: hidden;
  margin-top: 80px;
  .swiper-wrapper {
    width: 100% !important;
  }
}
.swiper-slide {
  overflow: hidden;
  width: 460px;
  height: 100%;
  text-align: left;
  background: #f8f8f8;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  img {
    width: 100%;
  }
  .title {
    text-align: left;
    margin: 29px 0 0 30px;
    font-size: 20px;
    font-family: Source Han Sans SC;
    font-weight: bold;
    color: #252930;
  }
  .desc {
    text-align: left;
    margin-top: 29px;
    margin-left: 32px;
    margin-bottom: 49px;
    width: 86%;
    font-size: 14px;
    font-family: Source Han Sans SC;
    font-weight: 500;
    color: #56595f;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .desc:hover {
    cursor: pointer;
  }
}
.button {
  width: 160px;
  height: 60px;
  line-height: 60px;
  background: #1966ff;
  margin: 127px auto;
  font-size: 18px;
  font-family: Source Han Sans SC;
  font-weight: bold;
  color: #ffffff;
}
.button:hover {
  cursor: pointer;
}
</style>
